import { render } from "./GroupMain.vue?vue&type=template&id=7602966a"
import script from "./GroupMain.vue?vue&type=script&lang=js"
export * from "./GroupMain.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__